import styled from 'styled-components';

import { color } from '../../helpers/style.helpers';

import { ShadowScrollContainer } from '@components/ShadowScrollContainer';

export const TableBody = styled(ShadowScrollContainer).attrs(() => ({
  forwardedAs: 'tbody',
}))`
  display: block;

  tr {
    /* display table to enable scroll
      https://stackoverflow.com/questions/23989463/how-to-set-tbody-height-with-overflow-scroll/23989771
    */
    display: table;
    width: 100%;
    table-layout: fixed;

    & + tr {
      /** handle the horizontal borders of the rows */
      border-top: 1px solid ${color.grey.light};
    }
  }
`;
